module.exports = __webpack_public_path__ + "img/o2.6087ba95.png";